import { TextField, Typography } from '@material-ui/core';
import {
  Column,
  Columns,
  Inline,
  Stack,
  useSnackbarStack,
} from '@superdispatch/ui';
import { Box, Button, TextBox } from '@superdispatch/ui-lab';
import { useState } from 'react';
import { trackEvent } from 'shared/helpers/Analytics';

interface InstantTransferReminderReasonCloseContentProps {
  onClose: () => void;
}

export function InstantTransferReminderReasonCloseContent({
  onClose,
}: InstantTransferReminderReasonCloseContentProps) {
  const { addSnackbar } = useSnackbarStack();
  const [feedback, setFeedback] = useState('');

  const onSendReason = () => {
    trackEvent(
      "Carrier Clicked Don't Show Me Again on Instant Transfer Reminder",
      {
        feedback: feedback || 'No Feedback',
      },
    );
    addSnackbar('Feedback Sent & Instant Transfer Reminders Turned Off.');
    onClose();
  };

  const onSkip = () => {
    trackEvent(
      "Carrier Clicked Don't Show Me Again on Instant Transfer Reminder",
      {
        feedback: 'Empty Field',
      },
    );
    addSnackbar('Instant Transfer Reminders Turned Off.');
    onClose();
  };

  return (
    <Box
      paddingLeft="medium"
      paddingRight="medium"
      paddingTop="small"
      paddingBottom="small"
    >
      <Stack space="medium">
        <Stack space="small">
          <Typography variant="h3">Turning off reminders? </Typography>
          <Typography>
            Your feedback matters! We&apos;d love to know why you&apos;re
            turning off Instant Transfer notifications. Your input helps us
            improve this new feature.
          </Typography>
          <TextField
            value={feedback}
            onChange={(e) => {
              setFeedback(e.target.value);
            }}
            multiline={true}
            fullWidth={true}
            label={
              <Columns>
                <Column>Reason</Column>
                <Column width="content">
                  <TextBox color="secondary">{feedback.length} of 100</TextBox>
                </Column>
              </Columns>
            }
            inputProps={{ maxLength: 100 }}
          />
        </Stack>
        <Stack align="right">
          <Inline space="small" verticalAlign="center">
            <Button variant="neutral" onClick={onSkip}>
              Skip
            </Button>
            <Button onClick={onSendReason}>Send</Button>
          </Inline>
        </Stack>
      </Stack>
    </Box>
  );
}
